import React from "react";

const getVisiblePages = (currentPage, lastPage) => {
  if (lastPage <= 5) {
    return Array.from({ length: lastPage }, (_, index) => index + 1);
  }

  const start = Math.max(Math.min(currentPage - 2, lastPage - 4), 1);

  return Array.from({ length: 5 }, (_, index) => start + index);
};

const Pagination = ({ meta = {}, onPageChange, label = "Pagination" }) => {
  const currentPage = Number(meta?.current_page ?? 1);
  const lastPage = Number(meta?.last_page ?? 1);

  if (lastPage <= 1) return null;

  const changePage = (nextPage) => {
    const safePage = Math.min(Math.max(nextPage, 1), lastPage);

    if (safePage !== currentPage) {
      onPageChange?.(safePage);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <nav className="ls-pagination" aria-label={label}>
      <ul>
        <li className="prev">
          <button type="button" disabled={currentPage === 1} onClick={() => changePage(currentPage - 1)}>
            <i className="fa fa-arrow-left"></i>
          </button>
        </li>
        {getVisiblePages(currentPage, lastPage).map((pageNumber) => (
          <li key={pageNumber}>
            <button
              type="button"
              className={pageNumber === currentPage ? "current-page" : ""}
              onClick={() => changePage(pageNumber)}
            >
              {pageNumber}
            </button>
          </li>
        ))}
        <li className="next">
          <button type="button" disabled={currentPage === lastPage} onClick={() => changePage(currentPage + 1)}>
            <i className="fa fa-arrow-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
